import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'
import FullWidthImage from 'components/Full-Width-Image'

import contentImageUrl from '../static/img/content-refurbishment.jpg'

class Refurbishment extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div className="container">
          <SectionTitle
            icon="icon-refurbishment.svg"
            title="Refurbishment"
            titleMarginLarge
          />

          <div className="layout layout--content layout--pb-lg">
            <div className="layout__item layout__item--half">
              <p>The balance between refurbishment and knock down new build needs careful interpretation and financial modelling. The planning constraints for each heavily influence the decision together with the needs of the surrounding marketplace. Prior to refurbishment GDL undertake a full analysis to deliver the optimum route forward</p>
            </div>
            <div className="layout__item layout__item--half">
              <p><img src={contentImageUrl} alt="" /></p>
            </div>
          </div>
          <FullWidthImage
            image="hero-section-refurbishment.jpg"
          />
        </div>
      </React.Fragment>
    )
  }
}

export default Refurbishment;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Refurbishment.js